'use strict';

import React, {Component} from 'react';

import config from "../shared/config";
import auth from "../shared/auth";
import health from "../shared/health";
import Router from "./router";

class Panel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			config: null,
			loading: true
		};
	}

	loadConfig() {
		return new Promise((resolve, reject) => {
			config.load('/config.json', {}, (err) => {
				if (err) {
					console.error(`Couldn't load the panel configuration`, err);
					return reject(err);
				}
				console.debug('Panel configuration', config.data);
				resolve(config.data);
			});
		});
	}

	loadHealthStatus() {
		return new Promise((resolve, reject) => {
			health({}, (err, response) => {
				if (err) {
					console.error(`Couldn't load health status`, err);
					return reject(err);
				}
				resolve(response);
			});
		});
	}

	async componentDidMount() {
		await this.loadConfig();
		if (!auth.init()) {
			return;
		}
		await this.loadHealthStatus();
		this.setState({config: config.data, loading: false});
	}

	render() {
		if (this.state.loading) {
			return (<div className="cm-loading">Loading configuration file</div>);
		}

		return (
			<>
				<header id="cm-head">
					<div id="zerolight-logo"/>
					<div>
						<h1 id="billing-panel-title">Billing Panel</h1>
						<div id="billing-panel-version">Version: {this.state.config.Version}</div>
					</div>
				</header>
				<section id="cm-router">
					<Router/>
				</section>
			</>
		);

	}
}


export default Panel;